import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import * as contractActions from "../../actions/contractActions";
import * as customerActions from "../../actions/customerActions";
import * as codeActions from "../../actions/codeActions";
import * as userActions from "../../actions/userActions";
import * as modalActions from "../../actions/modalActions";
import * as contractTierActions from "../../actions/contractTierActions";

import HeaderWrapper from "../common/HeaderWrapper";
import ContractForm from "./ContractForm";
import ConfirmModal from "../common/ConfirmModal";
import Loading from "../common/Loading";

import { formatDate } from "../../helpers/date";

class ContractAddPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false
    };
  }

  componentDidMount = async () => {
    const { customers, users, actions, contractTiers } = this.props;
    this.setState({ loading: true });
    if (!customers.length) await actions.loadCustomers();
    if (!users.length) await actions.loadUsers();
    if (!contractTiers.length) actions.loadContractTiers();
    this.setState({ loading: false });
  };

  handleSave = async (contract) => {
    this.setState({ loading: true });
    if (contract.support_hours_start) {
      contract.support_hours_start = formatDate(
        contract.support_hours_start,
        "hh:mm a"
      );
    }
    if (contract.support_hours_end) {
      contract.support_hours_end = formatDate(
        contract.support_hours_end,
        "hh:mm a"
      );
    }
    this.props.actions.createContract(contract);
    this.setState({ loading: false });
  };

  handleCancel = () => {
    this.props.history.push("/app/contracts");
  };

  render() {
    const { customers, users, codes, contractTiers } = this.props;
    return (
      <React.Fragment>
        <HeaderWrapper breadcrumbs={[{ label: "Add Contract" }]} />
        {this.state.loading ? (
          <div className="loading-loader-load-container">
            <Loading active />
          </div>
        ) : (
          <div className="content-wrapper">
            <ContractForm
              contract={{}}
              customers={customers}
              users={users}
              codes={codes}
              contractTiers={contractTiers}
              onAdd={this.handleSave}
              onCancel={this.handleCancel}
              editing
              adding
              saving={this.props.savingContract}
            />
          </div>
        )}
        <ConfirmModal
          cancelLabel="No"
          confirmLabel="Yes"
          id="redirectToProjectModal"
          title="Go To Create Project "
          body="Do you want to add a new project with this contract?"
          close={async () => {
            this.setState({ loading: true });
            await this.props.history.push("/app/contracts");
            await this.props.actions.hideModal();
            await this.props.actions.loadContracts();
            this.setState({ loading: false });
          }}
          confirm={(contractCreated) => {
            this.props.history.push(
              `/app/contracts/${contractCreated._id}/projects/1`
            );
          }}
        />
      </React.Fragment>
    );
  }
}

ContractAddPage.propTypes = {
  actions: PropTypes.object.isRequired,
  savingContract: PropTypes.bool,
  customers: PropTypes.array,
  users: PropTypes.array,
  codes: PropTypes.array,
  history: PropTypes.object,
  contractTiers: PropTypes.array
};

function mapStatesToProps(state) {
  return {
    state: state.reducers,
    savingContract: state.reducers.savingContract,
    customers: state.reducers.customers,
    users: state.reducers.users,
    codes: state.reducers.codes,
    contractTiers: state.reducers.contractTiers
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...contractActions,
        ...customerActions,
        ...userActions,
        ...codeActions,
        ...modalActions,
        ...contractTierActions
      },
      dispatch
    )
  };
}

export default connect(mapStatesToProps, mapDispatchToProps)(ContractAddPage);
